export function setupSearch(): void {
    $('.search').on('click', function () {
        if ($('.search-btn').hasClass('fa-search')) {
            $('.search-open').fadeIn(500);
            $('.search-btn').removeClass('fa-search').addClass('fa-times');
        } else {
            $('.search-open').fadeOut(500);
            $('.search-btn').addClass('fa-search').removeClass('fa-times');
        }
    });
}
